<template>
  <div class="pb-5">
    <nav-bar/>
    <chat-page/>
    <ticket-button/>

    <table-element
      :isShowFilter="true"
      :title="$t('Search.title')"
      :fields="fieldsObj"
      :arrOfElement="orders.deliveries"
      :sortSpacing="0"
      :initialSort="'orderNb'"
      class="card mx-2 my-4"
      @updateFilterResults="updateFilterResults"
    >
      <template #header-actions>
        <div v-if="companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'" class="row">
          <regular-select
            :value="search.archive"
            @change="search.archive = $event"
            :placeholder="$t('Type de recherche')" class="col-12 col-sm-6 col-lg-3 form-group">
            <option value="0">{{$t('Régulières')}}</option>
            <option value="1">{{$t('Archives 0-80')}}</option>
            <option value="2">{{$t('Archives 80-160')}}</option>
          </regular-select>
        </div>
        <div class="row">
          <regular-input
            :value="search.id"
            @input="search.id = $event"
            type="text" :placeholder="$t('Search.order')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.VIN"
            @input="search.VIN = $event"
            type="text" :placeholder="$t('Search.VIN')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.referenceNumber"
            @input="search.referenceNumber = $event"
            type="text" :placeholder="$t('Search.reference')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.source"
            @input="search.source = $event"
            type="text" :placeholder="$t('Search.source')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.pickup"
            @input="search.pickup = $event"
            type="text" :placeholder="$t('Search.pickup')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.delivery"
            @input="search.delivery = $event"
            type="text" :placeholder="$t('Search.delivery')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.billing"
            @input="search.billing = $event"
            type="text" :placeholder="$t('Search.billing')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-select-status
            :hiddenStatusMap="['processing', 'inspect']"
            @emitStatusSelect="onStatusSelect"
            class="col-12 col-sm-6 col-lg-3 form-group"
          />
          <regular-input
            :value="search.dateReceptionMin"
            @input="search.dateReceptionMin = $event"
            type="date" placeholder="Date min" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.dateReceptionMax"
            @input="search.dateReceptionMax = $event"
            type="date" placeholder="Date max" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-datalist-driver
            :value="search.driver"
            @input="search.driver = $event.value"
            :secondList="liste"
            :placeholder="$t('Search.driver')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <regular-input
            :value="search.nbSageOne"
            @input="search.nbSageOne = $event"
            type="text" :placeholder="$t('Search.sageone')" class="col-12 col-sm-6 col-lg-3 form-group"/>
          <div class="col-6">
            <button class="btn btn-kne-orange w-100" @click="clear()">
              {{$t('Search.clear')}}
            </button>
          </div>
          <div class="col-6">
            <button class="btn btn-kne-orange w-100" :disabled="!oneInputFilled" @click="submitSearch()">
              {{$t('Search.submit')}}
            </button>
          </div>
        </div>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="order.orderNb"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'transfered': order.status === 'Transférée'
          }">
          <td>
            <button type="button" class="btn btn-kne-orange pull-right"  @click="onViewOrder(order.orderNb)">
              {{$t('OrderCurrent.view')}}
            </button>
          </td>
          <td class="nowrap">{{order.orderNb}}
            <hover-tool-tip
            top
            right
            :text="`
            REF: ${order.reference || '-'} <br>
            SOURCE: ${order.source || '-'} <br>
            VIN: ${order.vin || '-'} <br>
            `"
            clickable
            />
          </td>
          <td class="nowrap">{{getDate(order.date) || '-'}}</td>
          <td class="nowrap">{{shortenString(order.pickup) || '-'}}
            <hover-tool-tip
              v-if="order.pickup.length > 22"
              right
              top
              :text="order.pickup"
              :clickable="true"
            />
            </td>
          <td class="nowrap">{{shortenString(order.delivery) || '-'}}
            <hover-tool-tip
              v-if="order.delivery.length > 22"
              right
              top
              :text="order.delivery"
              :clickable="true"
            />
            </td>
          <td class="nowrap">{{shortenString(order.billing) || '-'}}
            <hover-tool-tip
              v-if="order.billing.length > 22"
              left
              top
              :text="order.billing"
              :clickable="true"
            />
          </td>
          <td class="nowrap">
            {{order.vin}}
            <!-- <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
            <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
            <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
            <span v-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
            <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
            <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
            <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
            <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
            <span v-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
            <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span> -->
          </td>
          <td class="nowrap">{{order.driver || '-'}}</td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <!-- List of orders -->
        <div v-if="orders.deliveries.length > 0">
          <transition-group name="fade">
            <div class="card my-3 mx-2" v-for="order in content.results" :key="order.orderNb"
              :class="{
                'drop': order.status === 'Drop',
                'cancel': order.status === 'Cancel',
                'waiting': order.status === 'Attente',
                'pick': order.status === 'Pick',
                'transit': order.status === 'Transit',
                'dispatch': order.status === 'Dispatch',
                'reject': order.status === 'Reject'
              }">
              <div class="card-header m-2">
                <h4>{{order.orderNb}}</h4>
                <h6><i class="fa fa-calendar"></i>{{getDate(order.date)}}</h6>
                <h6 v-if="order.status === 'Dispatch'"><i class="fa fa-exclamation"></i> {{$t('Search.status.dispatch')}}</h6>
                <h6 v-if="order.status === 'Processing'"><i class="fa fa-exclamation"></i> {{$t('Search.status.processing')}}</h6>
                <h6 v-if="order.status === 'Pick'"><i class="fa fa-exclamation"></i> {{$t('Search.status.pick')}}</h6>
                <h6 v-if="order.status === 'Attente'"><i class="fa fa-exclamation"></i> {{$t('Search.status.waiting')}}</h6>
                <h6 v-if="order.status === 'Transit'"><i class="fa fa-exclamation"></i> {{$t('Search.status.transit')}}</h6>
                <h6 v-if="order.status === 'Drop'"><i class="fa fa-exclamation"></i> {{$t('Search.status.drop')}}</h6>
                <h6 v-if="order.status === 'Cancel'"><i class="fa fa-exclamation"></i> {{$t('Search.status.canceled')}}</h6>
                <h6 v-if="order.status === 'Terminée'"><i class="fa fa-exclamation"></i> {{$t('Search.status.finished')}}</h6>
                <h6 v-if="order.status === 'Transférée'"><i class="fa fa-exclamation"></i> {{$t('Search.status.transfered')}}</h6>
                <h6 v-if="order.status === 'Reject'"><i class="fa fa-exclamation"></i> {{$t('Search.status.rejected')}}</h6>
              </div>
              <div class="m-2">
                <h6><i class="fa fa-asterisk"></i>{{order.reference || '-'}}</h6>
                <h6><i class="fa fa-info-circle"></i>{{order.source || '-'}}</h6>
                <h6><i class="fa fa-user"></i>{{order.driver || '-'}}</h6>
                <h6><i class="fa fa-car"></i>{{order.vin || '-'}}</h6>
                <h6><i class="fa fa-home"></i>{{order.pickup || '-'}}</h6>
                <h6><i class="fa fa-truck"></i>{{order.delivery || '-'}}</h6>
                <h6><i class="fa fa-credit-card"></i>{{order.billing || '-'}}</h6>
              </div>
              <div id="action">
                <a :href="'#/OrderInfo?orderId=' + order.orderNb">
                  <input type="button" class="btn btn-kne-orange m-2" :value="$t('OrderCurrent.view')">
                </a>
              </div>
            </div>
          </transition-group>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

  </div>
</template>

<script>
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import HoverToolTip from '../module/basic-components/HoverToolTip.vue'
  import ChatPage from '../module/interface-components/ChatPage.vue'
  import TicketButton from '../module/interface-components/TicketButton.vue'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import RegularSelectStatus from '../module/basic-components/RegularSelectStatus.vue'

  import _ from 'lodash'
  import {db, dbArchives, dbArchives2} from '../../firebase'

  export default {
    name: 'Search',

    components: {
      regularInput,
      regularCheckbox,
      regularTextarea,
      regularSelect,
      regularDatalistDriver,
      HoverToolTip,
      ChatPage,
      TicketButton,
      TableElement,
      LoadingRender,
      RegularSelectStatus
    },

    data () {
      return {
        orders: {
          deliveries: []
        },
        searchArchive: {
          id: ''
        },
        search: {
          id: '',
          VIN: '',
          referenceNumber: '',
          source: '',
          pickup: '',
          delivery: '',
          dateReceptionMin: '',
          dateReceptionMax: '',
          status: '',
          driver: '',
          billing: '',
          nbSageOne: ''
        },
        invalid: false,
        searchHistory: [],
        searchType: '',
        searchText: '',
        historyTypeTag: '',
        fieldsObj: [
          {
            text: '',
            type: '',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.order'),
            type: 'orderNb',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.date'),
            type: 'date',
            value: ''
          },
          {
            text: this.$t('Search.pickup'),
            type: 'pickup',
            value: ''
          },
          {
            text: this.$t('Search.delivery'),
            type: 'delivery',
            value: ''
          },
          {
            text: this.$t('Search.billing'),
            type: 'billing',
            value: ''
          },
          {
            text: this.$t('OrderCurrent.VIN'),
            type: 'vin',
            value: ''
          },
          {
            text: this.$t('Search.driver'),
            type: 'driver',
            value: ''
          }
        ]
      }
    },

    created () {
      this.isLoading = false
      this.$store.state.isSidebarOpen = false
      this.isScreenSmall = window.innerWidth < 800

      if (this.$store.state.search !== null) {
        this.orders = JSON.parse(JSON.stringify(this.$store.state.search))
        this.search = JSON.parse(JSON.stringify(this.$store.state.searchFields))
      }

      this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
    },

    methods: {
      shortenString (text) {
        if (this.checkIsUndefined(text)) return text
        else {
          let subString = text.substring(0, 22)
          if (text.length > 22) subString += '...'
          return `${subString}`
        }
      },

      onStatusSelect (status) {
        this.search.status = status
      },

      updateFilterResults (sortResults) {
        this.filterResults = sortResults
      },

      setLastPage (toPage, fromPage) {
        this.$store.commit('SET_LAST_PAGE', toPage)
      },

      submitSearch () {
        console.log('Searching')
        var query = ''

        this.isLoading = true
        this.orders.deliveries = []
        if (this.search.id !== '') query = query + 'orderNb=' + this.search.id + '&'
        if (this.search.VIN !== '') query = query + 'vin=' + this.search.VIN + '&'
        if (this.search.referenceNumber !== '') query = query + 'reference=' + this.search.referenceNumber + '&'
        if (this.search.source !== '') query = query + 'source=' + this.search.source + '&'
        if (this.search.pickup !== '') query = query + 'pickup=' + this.search.pickup + '&'
        if (this.search.delivery !== '') query = query + 'delivery=' + this.search.delivery + '&'
        if (this.search.dateReceptionMin !== '') query = query + 'from=' + Date.parse(this.search.dateReceptionMin) + '&'
        if (this.search.dateReceptionMax !== '') query = query + 'to=' + Date.parse(this.search.dateReceptionMax) + '&'
        if (this.search.status !== '') query = query + 'status=' + this.search.status + '&'
        if (this.search.billing !== '') query = query + 'billing=' + this.search.billing + '&'
        if (this.search.driver !== '') query = query + 'driver=' + this.search.driver
        if (this.search.nbSageOne !== '') query = query + 'sageOne=' + this.search.nbSageOne
        if (query.slice(-1) === '&') query = query.slice(0, -1)

        if (this.search.archive === '1' || this.search.archive === '2') {
          window.axios.get('https://archivesapi.keepneye.com/archive' + this.search.archive + '/decode/search/' + this.companyUID + '/' + query).then((response) => {
            this.$store.commit('SET_LAST_PAGE', 0)
            this.$store.commit('STORE_SEARCH', response.data)
            this.$store.commit('STORE_SEARCH_FIELD', this.search)
            this.orders = response.data
            this.orders.deliveries.reverse()
          }).catch((error) => console.log(error))
        } else {
          window.axios.get('https://archivesapi.keepneye.com/search/decode/search/' + this.companyUID + '/' + query).then((response) => {
            this.$store.commit('SET_LAST_PAGE', 0)
            this.$store.commit('STORE_SEARCH', response.data)
            this.$store.commit('STORE_SEARCH_FIELD', this.search)
            this.orders = response.data
            this.orders.deliveries.reverse()
          }).catch((error) => console.log(error))
        }

        this.isLoading = false
        console.log('Search finished')
      },

      onViewOrder (orderId) {
        this.$router.push({name: 'OrderInfo', query: {orderId: orderId, archive: false, archivedOrder: true}})
      },

      submitSearchArchive () {
        if (this.search.archived === '0') {
          dbArchives2.ref('database/transporter/e58ff614-8449-4c3e-90b8-b42a48c2972b/deliveries').child(this.searchArchive.id).once('value').then((snap) => {
            if (snap.val()) {
              this.$router.push({name: 'OrderInfo', query: {orderId: this.searchArchive.id, archive: false, archivedOrder: true}})
            } else {
              this.invalid = true
              console.log('Not valid')
            }
          })
        } else {
          dbArchives.ref('database/transporter/e58ff614-8449-4c3e-90b8-b42a48c2972b/deliveries').child(this.searchArchive.id).once('value').then((snap) => {
            if (snap.val()) {
              this.$router.push({name: 'OrderInfo', query: {orderId: this.searchArchive.id, archive: true, archivedOrder: true}})
            } else {
              this.invalid = true
              console.log('Not valid')
            }
          })
        }
      },
      getDate: function (timestamp) {
        var date = new Date(timestamp)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
      },
      clear () {
        for (var attr in this.search) {
          this.search[attr] = ''
          this.orders.deliveries = []
          this.$store.commit('CLEAR_SEARCH')
        }
      },
      onResize: _.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    computed: {
      oneInputFilled: function () {
        var hasInput = false
        for (var attr in this.search) {
          if (this.search[attr] !== '') hasInput = true
        }
        return hasInput
      },
      companyUID () {
        return this.$store.state.authorization.company
      }
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
      if (this.$store.state.searchLastPage !== 0) this.$refs.paginator.goToPage(this.$store.state.searchLastPage)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  #addOrder{
    position: fixed;
    right: 1rem;
    bottom: 1rem;
  }
  #action{
    display: flex;
    justify-content: end;
  }
  .fa-exclamation{
    margin-left: 0.25rem;
  }
</style>
